import { Link } from '@tanstack/react-router';

import { cx } from '@libs/classnames';
import { pluralize } from '@libs/i18n';
import { useMediaQuery } from '@providers/MediaQueryProvider';

import { ClubLogo } from '@features/club/ui/ClubLogo';
import { components } from '@features/shared/api/public';

import styles from './ClubsList.module.css';

const MEMBERS_PLURAL = {
  one: 'участник',
  few: 'участника',
  many: 'участников',
  zero: 'участников',
};

const TOURNAMENTS_PLURAL = {
  one: '{number}\u000Aтурнир',
  few: '{number}\u000Aтурнира',
  many: '{number}\u000Aтурниров',
  zero: '{number}\u000Aтурниров',
};

type Props = {
  club: components['schemas']['ClubPublicDto'];
  highlighted?: boolean;
};

export function ClubsListItem({ club, highlighted }: Props) {
  const isMobile = useMediaQuery() === 'mobile';

  return (
    <div className={cx(styles.clubWrapper, { [styles.highlighted]: highlighted })}>
      <Link to="/club/$clubId" params={{ clubId: club.clubId }}>
        <ClubLogo className={styles.logo} logoUrl={club.logoUrl} />
      </Link>

      <div className={styles.clubItem}>
        <div className={styles.clubName}>
          <Link to="/club/$clubId" params={{ clubId: club.clubId }}>
            {club.title}
          </Link>
        </div>
        <div className={styles.clubInfo}>
          <div className={styles.clubParticipants}>
            {club.membersCount} {isMobile && pluralize(MEMBERS_PLURAL, club.membersCount)}
          </div>
          <div className={styles.clubEvents}>
            {pluralize(TOURNAMENTS_PLURAL, club.finishedTournamentsCount)}
          </div>
        </div>
      </div>
    </div>
  );
}
